import {
  ActiveInactiveStatus,
  ApiListRequest,
  ApiListResponse,
  SessionPackDTO,
  SessionPackSummaryDTO,
} from "@gymflow/types";
import {
  infiniteQueryOptions,
  QueryKey,
  queryOptions,
} from "@tanstack/react-query";

import { api } from "../../api";
import { numberPagination } from "../../numberPagination";

const keys = {
  all: () => ["memberApiCreditPack"] as QueryKey,
  id: (id?: unknown) => [...keys.all(), "id", id] as QueryKey,
  list: (filter: unknown) => [...keys.all(), "list", filter] as QueryKey,
  summary: (params: unknown) => [...keys.all(), "summary", params] as QueryKey,
};

export const memberApiCreditPack = {
  keys,
  queries: {
    id: (id: number | undefined) =>
      queryOptions({
        queryKey: keys.id(id),
        queryFn: async () => {
          return (await api.get<SessionPackDTO>(`/customer/sessionpack/${id}`))
            .data;
        },
        enabled: !!id,
      }),
    summary: (params: { sessionPackId: number; promotionCode?: string }) =>
      queryOptions({
        queryKey: keys.summary(params),
        queryFn: async () => {
          return (
            await api.post<SessionPackSummaryDTO>(
              `/customer/sessionpack/summary`,
              params,
            )
          ).data;
        },
      }),
  },
  infiniteQueries: {
    list: (
      params: {
        status?: ActiveInactiveStatus;
        id?: number[];
        hasActivityCategory?: boolean;
        hasAppointableCategory?: boolean;
        appointableCategories?: number[];
        classCategories?: number[];
      } & ApiListRequest,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.list(params),
        queryFn: async ({ pageParam }) => {
          return (
            await api.get<ApiListResponse<SessionPackDTO>>(
              `/customer/sessionpack`,
              {
                params: { ...params, page: pageParam },
              },
            )
          ).data;
        },
        ...numberPagination,
      }),
  },
  mutations: {},
};
